import React from 'react';
import ECharts from 'echarts-for-react';

const ScatterChart = ({ data, config, title }) => {
  const xAxisKey = config?.xAxis || (data?.length > 0 ? Object.keys(data[0])[0] : null);
  const yAxisKey = config?.yAxis || (data?.length > 0 ? Object.keys(data[0])[1] : null);
  const sizeKey = config?.sizeKey;

  if (!xAxisKey || !yAxisKey || !data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const scatterData = data.map((item) => [
    Number(item[xAxisKey]) || 0,
    Number(item[yAxisKey]) || 0,
    sizeKey ? Math.max(5, Math.min(50, Number(item[sizeKey]) || 10)) : 8,
  ]);

  const option = {
    title: {
      text: title || 'Scatter Chart',
      textStyle: { color: '#201e1d' },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#201e1d',
      borderColor: 'transparent',
      borderWidth: 0,
      borderRadius: 8,
      textStyle: { color: '#f5ead8' },
    },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    xAxis: {
      type: 'value',
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
      splitLine: { lineStyle: { color: '#eee7db' } },
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
      splitLine: { lineStyle: { color: '#eee7db' } },
    },
    series: [
      {
        data: scatterData,
        type: 'scatter',
        symbolSize: function (val) {
          return val[2];
        },
        itemStyle: {
          color: 'rgba(198, 113, 57, 0.75)',
        },
      },
    ],
  };

  return (
    <ECharts
      option={option}
      style={{ width: '100%', height: '400px' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default ScatterChart;
